import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const useCongratulationsStore = defineStore('congratulations', {
    state() {
        return {
            allCongratulations: []
        }
    },
    actions: {
        async getCongratulations(start, end, isForAdmins) {
            const data = {
                start,
                end,
                for_admins: isForAdmins
            }

            this.allCongratulations = await helper.api(
                'GET',
                '/congratulations',
                data
            )
        }
    }
})
